<template>
    <v-dialog v-model="showDialog" max-width="1000px" persistent scrollable>
      <v-card>
        <v-card-title class="bg-gray-light">
          <span class="text-h5 label-black">{{ title }}</span>
          <v-btn @click.prevent="handleConfirmCloseModal" class="ml-auto" icon>
            <v-icon id="close-button">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="headersComputed" :items="apiKeyList" sort-by="calories" item-key="index"
              class="elevation-2" mobile-breakpoint="0" fixed-header locale="ja" hide-default-header hide-default-footer :footer-props="{
                'items-per-page-options': [200]
              }">
              <template slot="no-data">
                {{ $t("notification.noData") }}
              </template>
              <template #header="{ props: {} }">
                <thead class="v-data-table-header">
                  <tr>
                    <th v-for="header in headersComputed" :key="header.value" scope="col">
                      {{ $t(header.text) }}
                    </th>
                  </tr>
                </thead>
              </template>
              <template v-slot:top>
                <v-toolbar flat>
                  <v-spacer></v-spacer>
                  <v-btn depressed color="primary" style="background-color: #3d76ad" @click="openAddApiKeyModal()">
                    <v-icon color="white" size="20" class="mr-2 dark mt-0">
                      mdi-plus-box
                    </v-icon>
                    <span style="font-size: 17px" class="font-weight-bold">{{
                        $t("labels.add")
                    }}</span>
                  </v-btn>
                </v-toolbar>
              </template>
                <template v-slot:[`item.no`]="{item}">
                  {{item.no}}
                </template>
                <template v-slot:[`item.apiKeyName`]="{item}">
                  <div style="margin: 5px">
                      <v-text-field :readonly="true" v-model="item.apiKeyName" outlined dense hide-details="true"
                      ></v-text-field>
                  </div>
                </template>
                <template v-slot:[`item.apiKey`]="{item}">
                  <div style="margin: 5px">
                      <v-text-field :readonly="true" v-model="item.apiKey" outlined dense hide-details="true"
                        :type="item.isApiKeyVisible ? 'text' : 'password'" 
                        append-icon="mdi-content-copy"
                        @click:append="copyToClipboard(item)"
                        @click:append-icon="togglePasswordVisibility(item)"
                      >
                        <template v-slot:append>
                          <v-icon @click="togglePasswordVisibility(item)">{{ item.isApiKeyVisible ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                          <v-icon @click="copyToClipboard(item)">mdi-content-copy</v-icon>
                        </template>
                      </v-text-field>
                  </div>
                </template>
                <template v-slot:[`item.action`]="{item}">
                  <div>
                    <button class="m-1" @click="confirmDeleteItem(item)">
                      <i class="fas fa-trash-alt text-danger fa-lg pt-2 pb-2">
                      </i>
                    </button>
                  </div>
                </template>

          </v-data-table>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="bg-secondary text-white" text @click.prevent="handleConfirmCloseModal">
            {{ $t("commonPopup.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64" style="color: #3d76ad !important;"></v-progress-circular>
      </v-overlay>
      <AddApiKeyModal @handleGetListApiKey="handleGetListApiKey"/>
    </v-dialog>
  </template>
  
  <script>
  import { EventBus } from '@/utils/eventBus.js'
  import { mapActions } from 'vuex';
  import {
    getCookieSiteUser, setCurrentPageCode
  } from "@/utils/auth";
  import $ from 'jquery';
  import { ResponseCode } from "@/constants/constants"
  import AddApiKeyModal from "@/modals/ApiKey/AddApiKeyModal";
import { readonly } from '@vue/composition-api';
  
  export default {
      name: "ApiKeyModal",
      props: ['visible', 'titleModal', 'frameId', 'session'],
      components: { AddApiKeyModal },
      data() {
          return {
              valid: false,
              loading: false,
              title: "",
              showDialog: false,
              PAGE_CODE: 'SA_CSM',
              apiKeyList: [],
              isPasswordVisible: false,
              siteId: null
  
          }
      },
      computed: {
        headersComputed() {
          return [
            { text: '#',align: 'start',sortable: false,value: 'no'},
            { text: this.$t('apiKey.apiKeyName'),align: 'start', sortable: false, value: 'apiKeyName',},
            { text: this.$t('apiKey.apiKey'), value: 'apiKey' },
            { text: this.$t('genba.table.action'), value: 'action', align: 'center' },
          ]
        }
      },
    created() {
          setCurrentPageCode(this.PAGE_CODE);
          EventBus.$on('handleOpenApiKeyModal', (value) => {
            const siteId = value.siteId;
            this.handleGetListApiKey(siteId);
            this.title = value.title;
            this.showDialog = value.flag;
            this.siteId = siteId;
          });
      },
      watch: {
          "$i18n.locale": async function () {
              this.getErrorCode("site");
          },
          showDialog(value) {
            if (value === false) {
              this.apiKeyList = []
            }
          }
          // 'showDialog'(val) {
          //   if (val) {
          //     this.generateShareLink();
          //   }
          // }
      },
      async beforeMount() {
          // import ERROR_CODES by language
          this.getErrorCode("site");
      },
      methods: {
          ...mapActions("sites", {
            getApiKeyList: "getApiKeyList",
            deleteApiKey: "deleteApiKey"
          }),
          copyToClipboard(item) {
            navigator.clipboard.writeText(item.apiKey).then(() => {
                this.snackbar = true;
                this.commonNotifyVue(this.ERROR_CODES['COPY_SUCCESS'], 'success');
            }).catch(err => {
                console.error('Error: ', err);
            });
          },
          togglePasswordVisibility(item) {
            const index = this.apiKeyList.findIndex(apiKey => apiKey.apiKeyId === item.apiKeyId);
            if (index !== -1) {
              this.$set(this.apiKeyList, index, {
                ...this.apiKeyList[index],
                isApiKeyVisible: !this.apiKeyList[index].isApiKeyVisible,
              });
            }
          },
          handleConfirmCloseModal() {
            this.showDialog = false
            $('#main-header').css("pointer-events", "");
          },
          handleGetListApiKey(siteId){
            this.getApiKeyList(siteId).then((response) => {
                if (response.code === ResponseCode.SUCCESS) {
                  this.apiKeyList = response.data;
                  if (response.data !== null && response.data.length > 0) {
                    for (let i = 0; i < this.apiKeyList.length; i++) {
                      this.apiKeyList[i].no = i + 1;
                      this.apiKeyList[i].isApiKeyVisible = false;
                    }
                  }
                }
                }).catch((error) => {

                }).finally(() => {
                  this.loading = false;
                })
          },
          openAddApiKeyModal() {
            EventBus.$emit('handleOpenAddApiKeyModal', {
              siteId: this.siteId,
              flag: true,
              title: this.$t('apiKey.apiKey')
            });
            $('#main-header').css("pointer-events", "none");
          },
          confirmDeleteItem(item) {
            // this.dialogDelete = true;
            this.apiKeyIdDeleteSelected = item.apiKeyId;
            this.commonConfirmVue(this.ERROR_CODES['CF_063_01_02'], () => {
              this.deleteApiKey(this.apiKeyIdDeleteSelected)
                .then(response => {
                  if (response.code === 0) {
                    this.handleGetListApiKey(this.siteId);
                    this.commonConfirmOKVue(this.ERROR_CODES['DELETE_SUCCESS'])
                  } else {
                    this.commonNotifyVue(this.ERROR_CODES[response.code], 'warning');
                  }
                })
                .catch(err => {
                  console.log(err);
                  if(err.code != undefined)
                    this.commonNotifyVue(this.ERROR_CODE[err.code], 'warning');
                })
                .finally(final => {
                });
            }, () => {
              this.apiKeyIdDeleteSelected = 0;
            })
          },
      }
  }
  </script>
  
  <style lang="scss" scoped>
  .width-150{
    width: 150px !important;
  }
  
  .sign {
    margin-top: 3px;
  }
  .setting-export-checkBox {
      margin-right: 50px !important
    }
  .v-card__actions {
      border-top: 1px solid #ebebeb;
  }
  
  .label-black {
      color: black !important;
  }
  
  .checkboxLabel {
      margin-top: 8px !important;
      font-weight: 100;
      color: black;
  }
  .radioLabel {
      margin-top: 8px !important;
      font-weight: 100;
      color: black;
  }
  
  
  ::v-deep{
    .v-dialog {
      box-shadow: none !important;
    }
    .v-card {
      margin-top: 2rem !important;
    }
    @media only screen and (min-width:768px) {
      .sign {
        margin-left: 2px !important;
      }
    }
    @media only screen and (max-width: 500px) and (max-height: 1000px) and (orientation: portrait){
    .v-card {
      margin-top: 5rem !important;
    }
    .setting-export-checkBox {
      margin-right: 0px !important
    }
    .v-dialog > .v-card > .v-card__text {
      padding: 0 0 0 0 !important;
    }
  }
    @media (min-width: 768px) and (max-width: 1366px) and (orientation: portrait) {
      .v.card {
        margin-top: 4em !important
      }
    }
  }
  </style>
  